import { PersonPregnancyTable } from 'src/features/persons/components'

export const PersonPregnancyPage = () => {
  return <PersonPregnancyTable />
}
